import React, { Component } from 'react';

import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

const ClientFormButtons = ({onClose, onSubmit}) => (
    <div>
        <FlatButton 
            label="Cancelar"
            primary={true}
            onTouchTap={onClose}
        />
        <FlatButton 
            label="Guardar"
            primary={true}
            onTouchTap={onSubmit}
        />
    </div>
)

class ClientDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open                : false,
            errorClient         : "",
            defaultClientName   : "",
            defaultDescription  : "",
            defaultLabels       : "",
            defaultClientID     : "",
            isUpdate            : false
        }
    }
    __openAndSetFields(data) {
        this.setState({
            defaultClientID     : data.clientID,
            defaultClientName   : data.clientName,
            defaultDescription  : data.description,
            defaultLabels       : data.labels,
            isUpdate            : data.isUpdate || false,
            open                : true
        });
    }
    _onClose() {
        this.setState({open: false});
    }
    _onSubmit() {
        let txtClient = document.getElementById("txtClient").value;
        let txtDescription = document.getElementById("txtDescription").value;
        let txtLabels = document.getElementById("txtLabels").value;

        if(txtClient.trim() === "") {
            this.setState({errorClient: "El nombre del cliente no puede estar vacío"});
        } else {
            if(this.state.isUpdate) {
                this.props.editClient({
                    clientID        : this.state.defaultClientID,
                    clientName      : txtClient,
                    description     : txtDescription,
                    labels          : txtLabels
                }, () => {
                    this._clearAndClose();
                });
            } else {
                this.props.addClient({
                    clientName: txtClient,
                    description: txtDescription,
                    labels: txtLabels
                }, () => {
                    this._clearAndClose();
                });
            }
        }
    }

    _clearAndClose() {
        this.setState({
            errorClient         : "",
            defaultClientName   : "",
            defaultDescription  : "",
            defaultLabels       : "",
            defaultClientID     : "",
            open                : false,
            isUpdate            : false
        });
    }

    _clearAndOpen() {
        this.setState({
            errorClient         : "",
            defaultClientName   : "",
            defaultDescription  : "",
            defaultLabels       : "",
            defaultClientID     : "",
            open                : true,
            isUpdate            : false
        });
    }

    render() {
        return(
            <div>
                <Dialog 
                    title = "Datos de cliente"
                    actions={
                        <ClientFormButtons 
                            onClose={this._onClose.bind(this)}
                            onSubmit={() => {
                                this._onSubmit();
                            }}
                        />
                    }
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this._onClose.bind(this)}
                    autoScrollBodyContent={true}
                >
                    <TextField
                        hintText="SAGRADO-PERU"
                        floatingLabelText="Cliente"
                        fullWidth={true}
                        id="txtClient"
                        errorText={this.state.errorClient}
                        defaultValue={this.state.defaultClientName}
                    />
                    <TextField 
                        hintText="Distribuidora Sagrado Perú"
                        floatingLabelText="Descripción"
                        fullWidth={true}
                        id="txtDescription"
                        defaultValue={this.state.defaultDescription}
                    />
                    <TextField 
                        hintText="BROTIZA, PRETINA"
                        floatingLabelText="Labels"
                        fullWidth={true}
                        id="txtLabels"
                        defaultValue={this.state.defaultLabels}
                    />
                </Dialog>
            </div>
        )
    }
}

export default ClientDialog;


// WEBPACK FOOTER //
// ./src/components/ClientDialog.js